import { Accent } from "@/components/kit/Accent";
import { KIT } from "@/constants/testIds";

/** The chapter opening of the book: a deep teal band that caps the cream reading sheet.
 *  Answers "where am I?" and "what am I reading?" before a single word of content. */
export const PageBand = ({ eyebrow, title, accent, intro, children }) => {
  // Only the FIRST occurrence of the accent word is coloured, so a title containing it twice
  // still renders in full.
  const at = accent && title ? title.indexOf(accent) : -1;
  const before = at >= 0 ? title.slice(0, at) : title;
  const after = at >= 0 ? title.slice(at + accent.length) : null;

  return (
    <header
      data-testid={KIT.pageBand}
      className="relative overflow-hidden rounded-b-[26px] bg-brand-tealDeep px-6 pb-7 pt-6 sm:px-10 sm:pb-8 sm:pt-7"
    >
      <div className="pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/[0.03]" />
      <div className="relative max-w-2xl">
        {eyebrow && (
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-white/60">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-2 font-display text-[26px] font-semibold leading-[1.15] text-white sm:text-[34px]">
          {after === null ? (
            /* No accent word declared: the shared rule picks one, so no headline is a flat tone. */
            <Accent>{title}</Accent>
          ) : (
            <>
              {before}
              <span className="text-brand-orange">{accent}</span>
              {after}
            </>
          )}
        </h1>
        {intro && (
          <p className="mt-4 text-[15px] leading-[1.65] text-white/75 sm:text-[16px]">{intro}</p>
        )}
        {children}
      </div>
    </header>
  );
};
